import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import swal from 'sweetalert';
import I18n from '../locales/i18n';
import Server from '../services/Server';

export default class ImageDropZone extends Component {
	constructor(props) {
		super(props);

		this.onDrop = this.onDrop.bind(this);
	}
	onDrop(acceptedFiles) {
		const self = this;

		let fd = new FormData();

		this.props.onRequestLoading(true);

		const { folder = 'none', name = '--' } = this.props;

		acceptedFiles.map((file) => {
			const _processFile = () => {
				fd.append('image', file);
				fd.append('folder', folder);
				fd.append('name', name);

				Server.sendGlobalPicture(fd)
					.then((response) => {
						if (response.status === 200) {
							self.props.onRequestLoading(false);
							const { ext, path } = response.data;
							self.props.onChangeImage({ name, ext, path });
						} else {
							self.props.onRequestLoading(false);
						}
					})
					.catch((error) => {
						console.error(error);
						swal(
							'Error',
							`En este momento no es posible cargar tu archivo, te recomendamos esperar unos momentos y reintentar ésta tarea`,
							'error'
						).then(() => {
							self.props.onRequestLoading(false);
						});
					});
				return false;
			};

			if (typeof this.props.onValidation === 'function') {
				this.props.onValidation(file, _processFile);
			} else {
				_processFile();
			}
			return true;
		});
	}

	render() {
		const { photoURL, name, isLoading } = this.props,
			_hasDelete = typeof this.props.onDeleteImage === 'function',
			imgElement = <img src={photoURL} alt="profile" />;

		return (
			<div className={this.props.className}>
				<Dropzone onDrop={this.onDrop}>
					{({ getRootProps, getInputProps }) => (
						<section className="drop-zone">
							{_hasDelete && (
								<button
									onClick={() => {
										this.props.onDeleteImage(name);
									}}
									type="button"
									className="btn-clean"
									disabled={isLoading}
								>
									<i
										className={
											'fas fa-' + (isLoading ? 'spinner fa-spin' : 'times')
										}
									/>{' '}
									{I18n('COMMON', 'CLEAR')}
								</button>
							)}
							<div {...getRootProps()}>
								<input
									{...getInputProps({
										accept: 'image/*',
										multiple: false,
									})}
								/>
								{imgElement}
								<small>{I18n('PROFILE', 'CLICK_ON_IMAGE_TO_CHANGE')}</small>
								<br />
							</div>
						</section>
					)}
				</Dropzone>
			</div>
		);
	}
}
